import React from "react";
import styled from "styled-components";
import Picture from "components/Picture";
import { getFilenamePrefix } from "utils/files";

const Avatar = styled(Picture)`
  width: auto;
  height: 100%;

  & > img {
    width: auto;
    height: 100%;
  }
`;

const AvatarContainer = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
`;

export default function PostAvatar(props) {
  const { avatar, title } = props;

  if (!avatar) return null;

  const imgSrcPrefix = getFilenamePrefix(avatar);

  return (
    <AvatarContainer>
      <Avatar image={avatar} imageAlt={`${title} avatar`} width={20} />
    </AvatarContainer>
  );
}
